// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Gh4k","right":"styles_right__2tDvf"};